module.exports = __webpack_public_path__ + "static/media/tos.beed4f1f.md";